<script>
import { manageStoreMethods } from "@state/helpers";
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    name: 'StoresModal',
    props: {
        activeCompany: {
            type: Object,
            required: false,
            default: () => {}
        },
        callback: {
            type: Function,
            required: false,
            default: () => {}
        },
        closeModal: {
            type: Function,
            required: true
        }
    },
    components: { 
        ValidationProvider, ValidationObserver
    },
    data() {
        return {
            newStore: {
                address: null,
                identification: null,
                brand: null,
            },
            isSubmitting: false,
            isModalVisible: true,
            assignModalShow: false,
            randomId: Math.random()
        }
    },
    methods: {
        ...manageStoreMethods,
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            const errors = Object.values(this.$refs.observer.errors).flat();
            if (!isValid) {
                this.$generate_noty('warn', this.$t('forms.form_errors', {'errors':errors.length}), this.$t('alerts.error'),  5000, true)
                return
            }
            this.assignModalShow = true;
        },
        saveStore(){
            let context = this
            this.isSubmitting = true
            const payload = (
                this.newStore.name &&
                this.newStore.address) ? {
                    name: this.newStore.name,
                    address: this.newStore.address,
                    company: this.activeCompany._id,
                    map: '653a8fd8ffa63b6c576ecc8d',
                } : null;
            if (!payload){
                const error = "Verifica los datos"
                this.$generate_noty('error', this.$t('forms.create_error'), error, 3000, true);
                this.cancel_or_error(error)
                this.isSubmitting = false
                return
            }
            this.createUpdateStore((payload)).then(resp => {
                context.isSubmitting = false
                context.callback(resp)
            })
        },
    },
    mounted(){

        
    },
}
</script>



<template>
    <div>
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="`${activeCompany && activeCompany.brand || ''}`" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observer" @submit.prevent="submitForm">
                <b-form ref="createform" >
                    <b-row>
                        <b-col md="12">
                            <h4>Nueva tienda/sucursal</h4>
                        </b-col>
                        <b-col md="6">
                            Nombre tienda:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="name"
                                :rules="{'required': true, 'min': 5 }">
                                <b-form-input v-model="newStore.name" type="text" name="name" placeholder="Nombre tienda/sede" />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="12">
                            Dirección:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="address"
                                :rules="{'required': false, 'min': 3 }">
                                <b-form-input v-model="newStore.address" type="text" name="address" placeholder="Dirección"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <!-- 
                            //TODO: Upload de img mapa
                            <b-col md="8">
                            Mapa:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="brand"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newStore.brand" type="text" name="brand" placeholder="Marca"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col> -->
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ $t("basic.add") }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="assign-modal"
            v-model="assignModalShow"
            :title="$t('basic.add')"
            :ok-title="$t('basic.add')"
            ok-variant="primary"
            @hidden="() => assignModalShow = false"
            @ok="saveStore"
            >
            <p v-if="newStore && newStore.address">
                <b>Está seguro de agregar esta nueva tienda/sucursal?</b>
                <br>
                <br>
                Nombre: <b>{{  newStore.name }}</b><br>
                Dirección: <b>{{  newStore.address }}</b><br>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>